var render = function render(){var _vm=this,_c=_vm._self._c;return _c('Inode',_vm._b({scopedSlots:_vm._u([{key:"filename",fn:function(){return [_vm._v(_vm._s(_vm.inode.parent.name)+"\n\n"+_vm._s(_vm.date?.length === 4 ? 'von' : 'vom')+"\n"),_c('strong',[_vm._v(_vm._s(_vm.date))]),(_vm.inode.name)?_c('i',[_vm._v("\n("+_vm._s(_vm.inode.name)+")")]):_vm._e()]},proxy:true}])},'Inode',_vm.settings,false))
}
var staticRenderFns = []

export { render, staticRenderFns }